import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
} from "recharts";
import { MdCalendarToday, MdTrendingUp } from "react-icons/md";
import "../../../styles/DashBoard_Home.css";
import { useEffect, useState } from "react";
import { apiFetch } from "../../../services/api";

export default function WarrantySummary() {

    const [ AllDevices, setAllDevices] = useState<any[]>([]);
    const [todayActivation, setTodayActivation] = useState<number>(0);
    const [monthlyActivation, setMonthlyActivation] = useState<number>(0);
    useEffect(() => {
      const fetchalldevices = async () => {
        try {
          const res = await apiFetch("/device/all-devices", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          });
          if (res && res.ok) {
            const result = await res.json();
            setAllDevices(result.Alldevices || []);
          }
        } catch (err) {
          console.error("Error fetching all devices:", err);
        }
      };

      const fetchActivationCount = async () => {
        try {
          const res = await apiFetch(`/device/activationcount`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          });
          if (res && res.ok) {
            const result = await res.json();
            setTodayActivation(result.todayActivations || 0);
            setMonthlyActivation(result.monthActivations || 0);
          } else {
            setTodayActivation(0);
            setMonthlyActivation(0);
          }
        } catch (err) {
          console.error("Error fetching activation count:", err);
          setTodayActivation(0);
          setMonthlyActivation(0);
        }
      };

      fetchalldevices();
      fetchActivationCount();
    }, [setAllDevices, setMonthlyActivation, setTodayActivation]);
    // console.log(AllDevices);
    

    const Active = AllDevices.filter(device => device.warrantyApproved?.toLowerCase() === 'approved').length;
    const Expired = AllDevices.filter(device => device.warrantyApproved?.toLowerCase() === 'expired').length;
    // const Pending = AllDevices.filter(device => device.warrantyApproved?.toLowerCase() === "pending").length;
    const Pending = AllDevices.length - (Active+Expired);
  
    
    // console.log(Active, Expired, Pending);
    
    const data = [
      { name: "Active", value: Active, color: "#66BB6A" },
      { name: "Expired", value: Expired, color: "#F44336" },
      { name: "Pending", value: Pending, color: "#F9A825" },
    ];

    const total = data.reduce((sum, item) => sum + item.value, 0);
    return (
    <div className="summary-card">

      <h2>Warranty Activation Summary</h2>

      <div className="summary-content">

        <div className="chart-section">

          <div className="chart-wrapper">

            <ResponsiveContainer width={260} height={220}>
              <PieChart>
                <Pie
                  data={data}
                  innerRadius={45}
                  outerRadius={100}
                  dataKey="value"
                >
                  {data.map((item) => (
                    <Cell key={item.name} fill={item.color} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>

            <div className="center-text">
              <h1>{total.toLocaleString()}</h1>
              <span>Total</span>
            </div>

          </div>

        </div>

        <div className="legend-section">

          {data.map((item) => (
            <div className="legend-item" key={item.name}>

              <div className="legend-left">
                <span
                  className="dot"
                  style={{ background: item.color }}
                />
                {item.name}
              </div>

              <div className="legend-right">
                <strong>{item.value.toLocaleString()}</strong>

                <span className="dev-per">
                  {/* ({((item.value / total) * 100).toFixed(2)}%) */}
                  ({total > 0 ? ((item.value / total) * 100).toFixed(2) : ""}%)
                </span>
              </div>

            </div>
          ))}

        </div>

      </div>

      <div className="summary-footer">

        <div className="footer-box">
          <MdCalendarToday />
          {/* <div className="act-td"> */}
            <span>Today's Activations</span>
            <span className="dv-cnt" style={{ marginLeft:"50px", fontSize:"medium", fontWeight:"800"}}>{todayActivation}</span>
          {/* </div> */}

          {/* <h2>32</h2> */}
        </div>

        <div className="footer-box green">
          <MdTrendingUp />
          {/* <div className="act-mn"> */}
            <span>This Month's Activations</span>
            <span className="dv-cnt" style={{ marginLeft:"50px", fontSize:"medium", fontWeight:"800"}}>{monthlyActivation}</span>
          {/* </div> */}

          {/* <h2>487</h2> */}
        </div>

      </div>

    </div>
  );
}